import React, {useEffect, useState} from 'react';
import {observer} from "mobx-react";
import css from './tabBar.module.scss'
import {useHistory} from "react-router-dom";
import {makeAutoObservable} from "mobx";
import AiPluginUtil from "utils/aiPluginUtil";
import * as Api from "utils/api/api";
import classNames from "classnames";

export const TabBarValue = {
    Home: 'Home',
    AiLive: 'AiLive',
    Ai: 'Ai',
    Video: 'Video',
    News: 'News'
}

class TabBarStore {
    curValue = undefined;

    setCurValue(value) {
        this.curValue = value;
    }

    constructor() {
        makeAutoObservable(this)
    }
}

const tabBarStore = new TabBarStore()

const TabBar = ({tabBarValue = TabBarValue.Home}) => {

    const history = useHistory()

    const [aiConfig, setAiConfig] = useState({})
    useEffect(() => {
        Api.aiConfig().then(data => {
            setAiConfig(data)
        })
    }, []);


    useEffect(() => {
        tabBarStore.curValue = tabBarValue
    }, [tabBarValue]);


    const onClickTabBar = (tabBarValue) => {
        if (tabBarValue === TabBarValue.Home) {
            history.push('/home')
        } else if (tabBarValue === TabBarValue.AiLive) {
            history.push('/ai-live')
        } else if (tabBarValue === TabBarValue.Ai) {
            AiPluginUtil.toAiText({aiConfig})
        } else if (tabBarValue === TabBarValue.Video) {
            history.push('/videos')
        } else if (tabBarValue === TabBarValue.News) {
            history.push('/news')
        }
    }

    return (
        <div className={css.tabBar}>
            <img className={css.bgImgShadow} src={require('./img/导航栏阴影.png')}/>
            <img className={css.bgImg} src={require('./img/导航栏背景.png')}/>
            <div className={css.container}>
                <div className={css.aiTabItemWrapper} onClick={() => onClickTabBar(TabBarValue.Ai)}>
                    <img className={css.icon} src={require('./img/ai.png')} alt=""/>
                </div>

                <div className={css.leftContainer}>
                    {/*首页*/}
                    <div className={classNames(css.itemWrapper)}>
                        <button className={css.btn} onClick={() => onClickTabBar(TabBarValue.Home)}>
                            {
                                tabBarStore.curValue === TabBarValue.Home ?
                                    <img className={classNames(css.icon, css.home)}
                                         src={require('./img/首页-active.png')} alt=""/>
                                    : <img className={classNames(css.icon, css.home)} src={require('./img/首页.png')}
                                           alt=""/>
                            }
                            <span className={css.text}>首页</span>
                        </button>
                    </div>
                    {/*Ai 直播*/}
                    <div className={classNames(css.itemWrapper)}>
                        <button className={css.btn} onClick={() => onClickTabBar(TabBarValue.AiLive)}>
                            {
                                tabBarStore.curValue === TabBarValue.AiLive ?
                                    <img className={classNames(css.icon, css.aiLive)}
                                         src={require('./img/直播-active.png')} alt=""/>
                                    : <img className={classNames(css.icon, css.aiLive)} src={require('./img/直播.png')}
                                           alt=""/>
                            }
                            <span className={css.text}>直播</span>
                        </button>
                    </div>
                </div>
                <div className={css.rightContainer}>
                    {/*Videos*/}
                    <div className={classNames(css.itemWrapper)}>
                        <button className={css.btn} onClick={() => onClickTabBar(TabBarValue.Video)}>
                            {
                                tabBarStore.curValue === TabBarValue.Video ?
                                    <img className={classNames(css.icon, css.video)}
                                         src={require('./img/短视频-active.png')} alt=""/>
                                    : <img className={classNames(css.icon, css.video)} src={require('./img/短视频.png')}
                                           alt=""/>
                            }
                            <span className={css.text}>短视频</span>
                        </button>
                    </div>
                    {/*资讯*/}
                    <div className={classNames(css.itemWrapper)}>
                        <button className={css.btn} onClick={() => onClickTabBar(TabBarValue.News)}>
                            {
                                tabBarStore.curValue === TabBarValue.News ?
                                    <img className={classNames(css.icon, css.news)}
                                         src={require('./img/资讯-active.png')} alt=""/>
                                    : <img className={classNames(css.icon, css.news)} src={require('./img/资讯.png')}
                                           alt=""/>
                            }
                            <span className={css.text}>资讯</span>
                        </button>
                    </div>
                </div>

                {/*Ai*/}
                {/*<div className={classNames(css.itemWrapper, {*/}
                {/*    [css.active]: tabBarStore.curValue === TabBarValue.Ai*/}
                {/*})}>*/}
                {/*    <button className={css.btn} onClick={() => onClickTabBar(TabBarValue.Ai)}>*/}
                {/*        <img className={css.icon} src={require('./img/ai.png')} alt=""/>*/}
                {/*    </button>*/}
                {/*</div>*/}

            </div>
        </div>
    )
}

export default observer(TabBar)